/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

export const NetworkGeneralInfo: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 24 24' {...props}>
        <G clipPath='url(#clip0_10870_99714)'>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3 8H8V24H3V8ZM4 0H7V2H4V0ZM0 3H11L9 7H2L0 3ZM16.845 9L18.028 5.2H15.422L14.705 6.155H14L14.466 4.495L14 2.844H14.705L15.422 3.776H18.028L16.845 0H17.777L20.155 3.777H22.761C22.958 3.777 23.125 3.846 23.261 3.982C23.3283 4.04884 23.3812 4.12874 23.4165 4.21679C23.4517 4.30485 23.4686 4.39919 23.466 4.494C23.4679 4.5871 23.451 4.67963 23.4162 4.76603C23.3815 4.85243 23.3296 4.93091 23.2638 4.99676C23.1979 5.0626 23.1194 5.11446 23.033 5.14922C22.9466 5.18397 22.8541 5.20091 22.761 5.199H20.155L17.777 9H16.845ZM17.62 15.135V13.12H15.65V15.136H17.618L17.62 15.135ZM17.62 21.151V16.151H15.65V21.151H17.618H17.62ZM16.635 11.5C17.665 11.5 18.617 11.757 19.493 12.272C20.3298 12.7475 21.0225 13.4402 21.498 14.277C22.013 15.153 22.27 16.106 22.27 17.135C22.27 18.165 22.013 19.117 21.498 19.993C21.0225 20.8298 20.3298 21.5225 19.493 21.998C18.628 22.5097 17.64 22.7766 16.635 22.77C15.63 22.7766 14.642 22.5097 13.777 21.998C12.9416 21.515 12.2496 20.8185 11.772 19.98C11.2614 19.1192 10.9945 18.1358 11 17.135C11 16.115 11.257 15.167 11.772 14.291C12.2573 13.4533 12.9533 12.7573 13.791 12.272C14.6515 11.7616 15.6345 11.4947 16.635 11.5Z'
                fill='#E5E5E6'
            />
        </G>
        <Defs>
            <ClipPath id='clip0_10870_99714'>
                <Rect fill='white' />
            </ClipPath>
        </Defs>
    </Svg>
)
